import React from "react";

import IOption from "common/models/IOption";
import { IWidgetProps } from "decorator-form";
import ButtonSelect from "./common/ButtonSelect";

const options: IOption[] = [
	{icon: "align-left", value: "left", default: true},
	{icon: "align-center", value: "center"},
	{icon: "align-right", value: "right"}
];

const AlignmentWidget: React.SFC<IWidgetProps<string>> = (props) => {
	return <ButtonSelect {...props} options={options} />;
};

export default AlignmentWidget;



// WEBPACK FOOTER //
// ./src/common/form/widgets/AlignmentWidget.tsx